import { render, staticRenderFns } from "./PelastuskorttiSelain.vue?vue&type=template&id=3451d232&scoped=true"
import script from "./PelastuskorttiSelain.vue?vue&type=script&lang=js"
export * from "./PelastuskorttiSelain.vue?vue&type=script&lang=js"
import style0 from "./PelastuskorttiSelain.vue?vue&type=style&index=0&id=3451d232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3451d232",
  null
  
)

export default component.exports